module.exports = __webpack_public_path__ + "static/media/daaji.57290646.jpg";